<div class="login-wrapper">
    <app-loader *ngIf="isLoading"></app-loader>
    <div class="login-container">
      <div class="header">
        <div class="left">Reset Password</div>
        <div class="right">
          <img src="assets/MoveinSync-Rentlz.png" class="mr-20 logo" />
        </div>
      </div>
      <ng-container *ngIf="passwordReset">
        <div class="mb-10">Your password has been updated successfully</div>
        <a class="redirect-link" [routerLink]="loginLink">Back to login</a>
      </ng-container>
      <ng-container *ngIf="!passwordReset">
        <div class="content direction-column">
          <form [formGroup]="formDetails" class="login-form">
            <div class="form-control mb-20">
              <div class="form-label mb-10">Password</div>
              <app-text-input type="password" [formControl]="formDetails.get('password')" class="form-input"></app-text-input>
            </div>
            <div class="form-control mb-20">
              <div class="form-label mb-10">Confirm Password</div>
              <app-text-input type="password" [formControl]="formDetails.get('confirmPassword')" class="form-input"></app-text-input>
              <div class="error-msg" *ngIf="showValidationError && formDetails.errors && formDetails.errors.passwordMatch">Passwords do not match</div>
            </div>
          </form>
        <div class="mb-10 font-size-14">
            {{errorMsg}}
        </div>
        </div>
        <div class="footer">
          <!-- <app-toast *ngIf="showError" message="Update password Failed" (dismissCallback)="dismissError()"></app-toast> -->
          <app-button type="primaryFilled" text="Update Password" class="mr-20" (clickCallback)="onSubmit()"></app-button>
        </div>
      </ng-container>
    </div>
  </div>
